'use client';

import { c as _c } from "react/compiler-runtime";
import type React from 'react';
import { ManageAttachment, UPLOAD_ENDPOINT, UploadFilesButton } from '../../../../actions/Attachments';
import { P2 } from '../../../../typography/Paragraph';
import type { AttachmentFile } from './types';
import { UploadButton } from './uploadAdapter';
export type ManageAttachmentsProps = {
  files: AttachmentFile[];
  setFiles: (files: AttachmentFile[]) => void;
  disabled?: boolean;
};
export const ManageAttachments: React.FC<ManageAttachmentsProps> = t0 => {
  const $ = _c(13);
  const {
    files,
    setFiles,
    disabled: t1
  } = t0;
  const disabled = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== files || $[1] !== setFiles) {
    t2 = uploaded => {
      setFiles([...files, ...uploaded]);
    };
    $[0] = files;
    $[1] = setFiles;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const handleUpload = t2;
  let t3;
  if ($[3] !== disabled || $[4] !== handleUpload) {
    t3 = <UploadFilesButton UploadButton={UploadButton} endpoint={UPLOAD_ENDPOINT.ATTACHMENT} setFiles={handleUpload} disabled={disabled} />;
    $[3] = disabled;
    $[4] = handleUpload;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== disabled || $[7] !== files || $[8] !== setFiles) {
    t4 = files.length === 0 ? <P2 className="text-contentTertiary">Nie dołączono żadnych plików.</P2> : <div className="flex w-full flex-col gap-2">{files.map(file => <ManageAttachment key={file.key} file={file} files={files} setFiles={setFiles} disabled={disabled} />)}</div>;
    $[6] = disabled;
    $[7] = files;
    $[8] = setFiles;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t3 || $[11] !== t4) {
    t5 = <div className="flex flex-col items-start gap-2">{t3}{t4}</div>;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
};